module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('group', [_c('cell', {
    attrs: {
      "title": "将设备连接到路由器："
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "4.5em",
      "label-margin-right": "2em",
      "label-align": "right"
    }
  }, [_c('selector', {
    attrs: {
      "title": "wifi选择",
      "options": _vm.wifiList
    },
    model: {
      value: (_vm.wifiName),
      callback: function($$v) {
        _vm.wifiName = $$v
      },
      expression: "wifiName"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "密码",
      "type": _vm.passwordTypeIsText ? 'text' : 'password',
      "placeholder": "密码"
    },
    on: {
      "on-focus": function($event) {
        _vm.isBottomBtnUp = true
      },
      "on-blur": function($event) {
        _vm.isBottomBtnUp = false
      }
    },
    model: {
      value: (_vm.wifiPassword),
      callback: function($$v) {
        _vm.wifiPassword = $$v
      },
      expression: "wifiPassword"
    }
  }, [_c('button', {
    staticClass: "password-btn",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.passwordIconClick
    },
    slot: "right"
  }, [(!_vm.passwordTypeIsText) ? _c('i', {
    staticClass: "iconfont icon-eye font-size-m"
  }) : _vm._e(), _vm._v(" "), (_vm.passwordTypeIsText) ? _c('i', {
    staticClass: "iconfont icon-eye-close font-size-m"
  }) : _vm._e()])])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "next-btn",
    class: {
      'position-static': _vm.isBottomBtnUp
    }
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.startLinkClick
    }
  }, [_vm._v("开始连接")])]), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.isLoading,
      "text": "连接wifi中"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect-wifi-tips"
  }, [_c('p', [_vm._v("暂不支持5G频段的wifi网络")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d0c208"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/wifi/ConnectWifi.vue
// module id = 883
// module chunks = 1